/* unplugin-vue-components disabled */import { render } from "./LogicalQuestionSelector.vue?vue&type=template&id=68202935&scoped=true"
import script from "./LogicalQuestionSelector.vue?vue&type=script&lang=js"
export * from "./LogicalQuestionSelector.vue?vue&type=script&lang=js"

import "./LogicalQuestionSelector.vue?vue&type=style&index=0&id=68202935&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68202935"]])

export default __exports__